import { render } from "./list-collapse.vue?vue&type=template&id=44641d6b"
import script from "./list-collapse.vue?vue&type=script&lang=js"
export * from "./list-collapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__